import styled from "@emotion/styled";
import { MdsIcon } from "@/design-system/components/icon";
import { MDSListBoxItem } from "@/mds/components/lists/list-box-item";

export const StyledListBoxItem = styled(MDSListBoxItem)(
  ({ theme }) => `
  padding: ${theme.spacing[2]} ${theme.spacing[5]};
  border: none;
  border-radius: 0;
  margin: 0;
  min-height: 50px;
  align-items: flex-start;
  cursor: pointer;
  background-color: ${theme.colors.background.menu.default};

  &[data-focused] {
    background-color: ${theme.colors.background.menu.hover};
  }

  &[data-selected] {
    background-color: ${theme.colors.background.menu.selected};
  }

  &:hover:not([data-disabled]) {
    background-color: ${theme.colors.background.menu.hover};
  }
`
);

export const StyledIconWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing[1]} 0;
`;

export const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
`;

export const StyledCollectionIcon = styled(StyledIconContainer)<{ iconColor: string }>`
  // For MdsIcon
  > div {
    width: 16px;
    height: 16px;
  }

  /* Ensure icon is white on colored background */
  svg {
    width: 16px;
    height: 16px;
    color: ${({ iconColor }) => iconColor};
  }
`;

export const StyledNoteIcon = styled(StyledIconContainer)`
  // For MdsIocn
  > div {
    width: 16px;
    height: 16px;
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.icon.placeholder};
  }
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  min-width: 0;
  max-width: 100%;
`;

export const StyledTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  max-width: 100%;
`;

export const StyledTitle = styled.div`
  max-width: 100%;
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: ${({ theme }) => theme.lineHeights["paragraph-s"]};
  color: ${({ theme }) => theme.colors.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledMetadata = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledSharedIcon = styled(MdsIcon)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.colors.icon.secondary};
  flex-shrink: 0;
`;
